import NavigationSliderSecondary from './NavigationSliderSecondary'

export default NavigationSliderSecondary
